import React from "react";
import "../../styles/SettlementTab.css";

const SettlementTab = ({ payment }) => {

    const settlement = payment?.settlement;

    if (!settlement) return null;

    return (

        <div className="settlement-card">

            <h3>Settlement Information</h3>

            <div className="settlement-grid">

                <div>
                    <label>Status</label>
                    <p>{settlement.status}</p>
                </div>

                <div>
                    <label>Settlement Amount</label>
                    <p>₹{settlement.amount}</p>
                </div>

                <div>
                    <label>Commission</label>
                    <p>₹{settlement.commission}</p>
                </div>

                <div>
                    <label>Settlement Date</label>
                    <p>{settlement.date || "-"}</p>
                </div>

                <div>
                    <label>Settlement ID</label>
                    <p>{settlement.settlementId || "-"}</p>
                </div>

            </div>

        </div>

    );

};

export default SettlementTab;